import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, Typography } from '@mui/material';

import { FC, ReactNode } from 'react';

export const Field: FC<{
  infoTooltip?: ReactNode;
  label: string;
  value: ReactNode;
}> = props => (
  <div>
    <Typography color='text.secondary' variant='body2'>
      {props.label}
      {props.infoTooltip && (
        <Tooltip
          slotProps={{ tooltip: { sx: { maxWidth: 400 } } }}
          title={props.infoTooltip}>
          <InfoOutlinedIcon
            fontSize='small'
            sx={{ ml: 0.5, verticalAlign: 'text-bottom' }}
          />
        </Tooltip>
      )}
    </Typography>
    <Typography component='div' variant='body1'>
      {props.value}
    </Typography>
  </div>
);
